/* import __COLOCATED_TEMPLATE__ from './frequency-display.hbs'; */
import Component from '@glimmer/component';
import { numberToUserDisplay } from '@ebiz/pretty-num';
import { service } from '@ember/service';
import type Intl from 'ember-intl/services/intl';

interface FrequencyDisplayArgs {
  value: number | string | null;
  displayFormat?: string;
  roundValues?: boolean;
  significantDigits?: number;
}
interface FrequencyDisplaySignature {
  Args: FrequencyDisplayArgs;
  Element: HTMLSpanElement;
}

export default class FrequencyDisplay extends Component<FrequencyDisplaySignature> {
  @service declare intl: Intl;
  get displayFormat() {
    return this.args.displayFormat || 'Engineering';
  }
  get roundValues() {
    return this.args.roundValues || false;
  }
  get valueIsOkay(): boolean {
    if (this.args.value === null) {
      return false;
    }
    const tempValue = typeof this.args.value === 'string' ? parseFloat(this.args.value) : this.args.value;
    return tempValue !== null && !isNaN(tempValue);
  }
  get display(): string {
    if (this.args.value !== null) {
      const tempValue = typeof this.args.value === 'string' ? parseFloat(this.args.value) : this.args.value;
      const value = this.roundValues ? Math.round(tempValue) : tempValue;
      return numberToUserDisplay(value, this.displayFormat, this.args.significantDigits || 5, { showZeroes: false });
    } else {
      return '';
    }
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    FrequencyDisplay: typeof FrequencyDisplay;
  }
}
